'use client';

import { c as _c } from "react/compiler-runtime";
import { Mail, Xmark } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Button as RACButton } from 'react-aria-components';
import { useMedia } from 'react-use';
import { Button } from '~/components/Button';
import { SaveButton } from '~/components/Common/SaveButton';
import { trackEvent } from '~/utils';
import { EmailTripDialog } from './EmailTripDialog';
import styles from './SaveTripPromptContent.module.css';
interface SaveTripPromptContentProps {
  tripId: string;
  tripTitle: string;
  startDate?: string;
  endDate?: string;
  onDismiss: () => void;
}
export function SaveTripPromptContent(t0) {
  const $ = _c(37);
  const {
    tripId,
    tripTitle,
    startDate,
    endDate,
    onDismiss
  } = t0;
  const t = useTranslations("account");
  const aria = useTranslations("aria");
  const [isEmailOpen, setIsEmailOpen] = useState(false);
  const showEmail = process.env.NEXT_PUBLIC_FF_TRIP_EMAIL_ME === "true";
  const isCompact = useMedia("(max-width: 450px)", false);
  let t1;
  if ($[0] !== t) {
    t1 = t("trip_prompt_title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className={styles.title}>{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("trip_prompt_subtitle");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <p className={styles.subtitle}>{t3}</p>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className={styles.copy}>{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isCompact || $[12] !== t) {
    t6 = showEmail && <RACButton className={styles.emailButton} onPress={() => {
      trackEvent("trip_page_email_me_click", {
        event_category: "click",
        event_label: "trip-page-email-me"
      });
      setIsEmailOpen(true);
    }} aria-label={isCompact ? t("trip_prompt_email") : undefined}><Mail decorative={true} size="large" />{!isCompact && t("trip_prompt_email")}</RACButton>;
    $[11] = isCompact;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== endDate || $[15] !== isCompact || $[16] !== startDate || $[17] !== tripId) {
    t7 = <SaveButton tripId={tripId} startDate={startDate} endDate={endDate} noUnderline={true} iconOnly={isCompact} />;
    $[14] = endDate;
    $[15] = isCompact;
    $[16] = startDate;
    $[17] = tripId;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = <div className={styles.actions}>{t6}{t7}</div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== aria) {
    t9 = aria("close");
    $[22] = aria;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Xmark color="black" size="large" decorative={true} />;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== onDismiss || $[26] !== t9) {
    t11 = <Button isTransparent={true} size="small" variant="icon" onPress={onDismiss} ariaLabel={t9}>{t10}</Button>;
    $[25] = onDismiss;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== isEmailOpen || $[29] !== onDismiss || $[30] !== tripTitle) {
    t12 = showEmail && <EmailTripDialog isOpen={isEmailOpen} onOpenChange={setIsEmailOpen} tripTitle={tripTitle} onSuccess={onDismiss} />;
    $[28] = isEmailOpen;
    $[29] = onDismiss;
    $[30] = tripTitle;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t11 || $[33] !== t12 || $[34] !== t5 || $[35] !== t8) {
    t13 = <div className={styles.prompt}>{t5}{t8}{t11}{t12}</div>;
    $[32] = t11;
    $[33] = t12;
    $[34] = t5;
    $[35] = t8;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
}